import { useEffect, useRef } from "react";
import { useAuth } from "src/context";
import { useNavigate, Outlet } from "react-router-dom";

export default () => {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (!user) {
      timeoutRef.current = setTimeout(() => {
        navigate(`/login`);
      }, 2000);

      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = undefined;
        }
      };
    } else {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
      }
    }
  }, [user]);

  if (!user || !isAdmin) {
    return null;
  }

  return <Outlet />;
};
